var map = {
	"./datav1.svg": 5586,
	"./datav2.svg": 625,
	"./drone1.svg": 1058,
	"./drone2.svg": 4193,
	"./drone3.svg": 6275,
	"./drone4.svg": 4543,
	"./drone5.svg": 814,
	"./flight1.svg": 6732,
	"./flight2.svg": 2703,
	"./flight3.svg": 2654,
	"./flight4.svg": 33,
	"./menu0.svg": 3040,
	"./menu1.svg": 3601,
	"./menu10.svg": 7907,
	"./menu11.svg": 2738,
	"./menu12.svg": 3105,
	"./menu13.svg": 7152,
	"./menu14.svg": 3039,
	"./menu15.svg": 4606,
	"./menu16.svg": 2957,
	"./menu2.svg": 3202,
	"./menu3.svg": 3779,
	"./menu4.svg": 7036,
	"./menu5.svg": 2493,
	"./menu6.svg": 8126,
	"./menu9.svg": 8681,
	"./menuLeft.svg": 7035,
	"./menuRight.svg": 1550,
	"./message.svg": 8394,
	"./person.svg": 7598,
	"./pest1.svg": 1494,
	"./pest2.svg": 4453,
	"./pest3.svg": 9524,
	"./qa.svg": 9147,
	"./qrcode.svg": 8903,
	"./reback.svg": 2639,
	"./setting.svg": 7359,
	"./video.svg": 3512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3810;